import React from 'react';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

export default function Message({ text }) {
	const useStyles = makeStyles((theme) => ({
		textBold: {
			fontWeight: 'bold'
		}
	}));

	const classes = useStyles();

	return (
		<Typography variant="body1" component="p" className={classes.textBold}>
			{text}
		</Typography>
	);
}
